import headerBckBlank from '@/assets/headerBckBlank.png'
import { lightenHex } from '@/themes/createTheme.ts'

const mainColor = '#A40001'
const visionColor = '#FFE6E7'
const headerIconBorder = '#e96d51'
const headerIconBg = '#dc463d'

const rowSelectedBg = '#FFF0F0'
const rowSelectedHoverBg = '#FFE0E1' // 主题 衍生色  按钮背景  hover等效果

export default {
  cssVar: true,
  components: {
    Menu: {
      subMenuItemBg: '#ffffff', //左侧菜单子选项背景色
      itemHoverBg: '', //左侧菜单菜单项悬浮态背景色
      itemSelectedBg: visionColor,
      itemMarginInline: 0, //菜单项横向外间距
      iconSize: 16, //图标尺寸
      iconMarginInlineEnd: 4, //图标与文字间距
      algorithm: true,
    },
    Layout: {
      headerBg: '#FFFFFF',
      headerHeight: 60,
      headerPadding: '0 16px',
      triggerBg: '#FFFFFF',
      triggerColor: '#475366',
      bodyBg: '#F6F8FB',
      algorithm: true,
    },
    Button: {
      primaryShadow: '0 2px 0 rgba(0, 0, 0, 0)',
    },
    Select: {
      optionSelectedBg: visionColor,
    },
    TreeSelect: {
      nodeSelectedBg: visionColor,
    },
    DatePicker: {
      cellActiveWithRangeBg: visionColor,
    },
    Cascader: {
      optionSelectedBg: visionColor,
    },
    Table: {
      rowSelectedBg: rowSelectedBg,
      rowSelectedHoverBg: rowSelectedHoverBg,
    },
  },
  token: {
    colorPrimary: mainColor,
    controlItemBgActive: visionColor,
    controlOutlineWidth: 0,
  },
  themContent: {
    '--ant-primary-color': mainColor,
    '--theme-color': mainColor, // 主题色
    '--theme-vision': visionColor, // 主题 衍生色  按钮背景  hover等效果
    '--header-background-image': `url(${headerBckBlank})`, //顶部背景图  //https://static.shjmall.cn/sass/headerBck.png
    '--header-background-color': mainColor,
    '--header-icon-border': headerIconBorder, //  导航图标边框
    '--header-icon-bg': headerIconBg, //  导航图标背景
    '--menu-tag-name-color-check': mainColor, //顶部页签选中后名称颜色
    '--menu-tag-name-color-uncheck': '#A5B2CB', //顶部页签未选中名称颜色
    '--menu-tag-name-color-hover': mainColor, //顶部页签名称移入颜色

    '--menu-tag-background': visionColor, //顶部页签背景颜色

    '--ant-menu-item-selected-background-color': visionColor, //左侧菜单选中背景色 //#E1EDFE
    '--ant-menu-item-selected-background-color-hover': '#f7f8fa', //左侧菜单子选项移入背景色 //#f7f8fa

    '--ant-menu-subMenu-title-hover': mainColor, //左侧菜单父级名称移入颜色
    '--ant-menu-subMenu-item': mainColor, //左侧菜单可点击名称颜色

    '--ant-menu-subMenu-arrow': mainColor, //左侧菜单展开收起箭头颜色
    // '--ant-menu-first-item': 'bolder', //左侧菜单第一个元素加粗

    '--ant-table-row-selected-bg': rowSelectedBg, // 表格选中颜色
    '--ant-table-row-selected-hover-bg': rowSelectedHoverBg, // 表格选中 hover 颜色
  },
}
